import React from 'react';

import Modal from '../modals/Modal';

const LoginDetails = props => {
    const { closeModal, showDetailsModal,loginData } = props
   

    return (
        <Modal
            id="loginDetails"
            showModal={showDetailsModal}
            closeModal={closeModal}
            modalHeader="Login Details"
            >
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="box-row">
                        <div className="table-head">
                            <h1 className="sec-header">Merchant Login Details</h1>
                        </div>
                        <div className="card">
                            <div className="card-body box-row">


                                
                                <div style={{ position: 'absolute', top: '0px', right: '15px' }}>
                                </div>
                                <div style={{ margin: '0px 50px' }}>
                                    <div className="form-group row col-md-10">
                                        <div className="col-md-4"><span><b>User Name</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{loginData.username}</span></div>
                                    </div>

                                    <div className="form-group row col-md-10">
                                        <div className="col-md-4"><span><b>Password</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{loginData.password}</span></div>
                                    </div>

                                    <div className="form-group row col-md-10">
                                        <div className="col-md-4"><span><b>Api Key</b>{' '}:</span></div>
                                        <div className="col-md-8"><span>{loginData.apiKey}</span></div>
                                    </div>

                                    <div className="form-group row col-md-10">
                                        <div className="col-md-4"><span><b>Api URL</b>{' '}:</span></div>
                                        <div className="col-md-8"><span><a href={loginData.apiURL}>{loginData.apiURL}</a></span></div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
        </Modal>
    )
    
};

export default LoginDetails;